"use client";

import React from "react";
import useGetHeroImageByTag from "@/components/hooks/use-get-hero-image-by-tag";
import { Card, CardTitle } from "@/components/ui/card";
import BackgroundImage from "@/components/ui/layout/background-image";
import { MotionLink } from "@/components/ui/Motion";
import { TypographySmall } from "@/components/ui/typography";
import { cls, formatForUrl } from "@/lib/utils";
import type { FloorPlanName } from "../../types";
import { FLOOR_PLANS_DETAILS } from "./consts";

interface FloorPlansListItemProperties {
  title: FloorPlanName;
}

function FloorPlansListItem({ title }: FloorPlansListItemProperties) {
  const { bedrooms, bathrooms, sqft } = FLOOR_PLANS_DETAILS[title];
  const tag = `hero_floor_plans_${title.replace(/\s+/g, '_')}`;
  const { data: heroImage } = useGetHeroImageByTag({ tag });

  return (
    <div className={cls`block w-full h-full`}>
      {/* Clickable Background Image */}
      <MotionLink
        className={cls`relative w-full aspect-2/1 overflow-hidden rounded-xl flex`}
        href={`/floor-plans/${formatForUrl(title)}`}
      >
        <BackgroundImage
          src={heroImage ?? ''}
          alt={title}
          fill
          sizes="(max-width: 786px) 100vw, 50vw"
          overlay="bg-black/20 hover:bg-black/40 transition-all duration-300"
          imageProps={{
            showSkeleton: true,
            style: { objectFit: "fill" },
          }}
        >
          {/* Card Overlay */}
          <Card className={cls`absolute bottom-3 left-3 max-w-[50%] py-2 px-3`}>
            <div className="flex flex-col gap-1">
              <CardTitle className="text-xs">{title}</CardTitle>
              <div className="flex items-center gap-2 flex-wrap">
                <TypographySmall>{bedrooms} Beds</TypographySmall>
                <TypographySmall>{bathrooms} Baths</TypographySmall>
                <TypographySmall>{sqft} Sq. Ft.</TypographySmall>
              </div>
            </div>
          </Card>
        </BackgroundImage>
      </MotionLink>
    </div>
  );
}

export default FloorPlansListItem;
